import { SectionHeader } from '../components/SectionHeader'
import { NewsCard } from '../components/NewsCard'
import { useAdminArticlesStore } from '@/modules/admin/state/articlesStore'

export function NewsSection() {
  const articles = useAdminArticlesStore((s) => s.articles) ?? []
  const items = articles
    .filter((a) => a.status === 'published')
    .slice(0, 3)
    .map((a) => ({
      id: a.id,
      image: a.image,
      title: a.title,
      date: a.date,
      excerpt: a.excerpt,
      to: `/tin-tuc/${a.slug}`,
    }))

  if (items.length === 0) return null

  return (
    <section>
      <SectionHeader title="Tin Tức & Cẩm Nang" viewAllTo="/tin-tuc" />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {items.map((n) => <NewsCard key={n.id} item={n as any} />)}
      </div>
    </section>
  )
}
